import * as React from "react";

import { FormattedMessage } from "react-intl";
import { trackToggleFacetGroup } from "../../../../utils/SearchTrackingUtil";
import CollapseFilterWrapper from "./CollapseFilterWrapper";
import { isEmpty } from "shared/src/utils/util";

type Props = {
    children?: React.ReactNode;
    facetName: string | undefined | null;
    facetKey: string;
    initialOpen?: boolean;
};

export function FacetFilterComponentCollapsible(props: Props) {
    const facetName = !isEmpty(props.facetName) ? (
        props.facetName
    ) : (
        <FormattedMessage id={"EX_FILTER_PANEL_FACET_CAPTION_" + props.facetKey.toUpperCase()} />
    );
    const className = "ex-facet-filter-component test-facet-filter-component-" + props.facetKey;
    const trackToggle = (newState: boolean) => trackToggleFacetGroup(props.facetKey, "facet", newState);
    return (
        <CollapseFilterWrapper
            className={className}
            caption={facetName || ""}
            initialOpen={props.initialOpen}
            trackToggle={trackToggle}>
            {props.children}
        </CollapseFilterWrapper>
    );
}
